import alertType from "./alertType";

export const showAlert = () => ({
  type: alertType.SHOW_ALERT,
});
export const closeAlert = () => ({
  type: alertType.CLOSE_ALERT,
});

export const showSuccessAlert = (content) => ({
  type: alertType.SHOW_SUCCESS_ALERT,
  content: content,
});

export const showDangerAlert = (content) => ({
  type: alertType.SHOW_DANGER_ALERT,
  content: content,
});

export const showInfoAlert = (content) => ({
  type: alertType.SHOW_INFO_ALERT,
  content: content,
});

export const showModalAlert = (data) => ({
  type: alertType.SHOW_MODAL,
  ...data,
});

export const showSimAlert = () => ({
  type: alertType.SHOW_START_SIM_ALERT,
});
